import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

// Startup platform analytics from startup-backend: profile completion, pitch
// deck / video uploads, active users, session time, activity, rounds, startup
// profile views and data rooms. Same from/to (IST YYYY-MM-DD, inclusive) and
// the same { value, previous, delta_pct } metric shape as the other dashboard
// payloads.
export const PLATFORM_ANALYTICS_BLOCKS = {
    PROFILE_COMPLETION: 'profile-completion',
    UPLOADS: 'uploads',
    ACTIVE_USERS: 'active-users',
    SESSION_TIME: 'session-time',
    ACTIVITY: 'activity',
    ROUNDS: 'rounds',
    STARTUP_VIEWS: 'startup-views',
    DATA_ROOMS: 'data-rooms',
};

const fetchPlatformAnalytics = (path, { from, to } = {}) =>
    axios({
        method: 'get',
        url: `${process.env.REACT_APP_STARTUP_BASE_URL}/admin/platform-analytics${path ? `/${path}` : ''}`,
        params: { ...(from ? { from } : {}), ...(to ? { to } : {}) },
        headers: {
            'Authorization': `Bearer ${checkForAuthorization()}`
        },
    });

const queryOptions = {
    select: (data) => data?.data?.data ?? null,
    keepPreviousData: true,
    staleTime: 3 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
        return RetryOnError(failureCount, error)
    },
    onError: (err) => {
        return verifyToken(err)
    },
};

// Every block in one call - what the dashboard should use.
export const FetchPlatformAnalytics = ({ from, to }) => {
    return useQuery(
        ['platform-analytics', from, to],
        () => fetchPlatformAnalytics('', { from, to }),
        queryOptions,
    )
}

// One block on its own, e.g. FetchPlatformAnalyticsBlock({ block: PLATFORM_ANALYTICS_BLOCKS.ROUNDS, from, to }).
// profile-completion is a snapshot and ignores the range.
export const FetchPlatformAnalyticsBlock = ({ block, from, to }) => {
    return useQuery(
        ['platform-analytics', block, from, to],
        () => fetchPlatformAnalytics(block, { from, to }),
        { ...queryOptions, enabled: Boolean(block) },
    )
}
